import { StandardEvents } from '@shopify/events';

function showCount(quantity) {
  if (!Number.isInteger(quantity) || quantity < 0) return;
  document.querySelectorAll('[data-wpi-bag]').forEach((bag) => {
    const count = bag.querySelector('[data-wpi-cart-count]');
    count.textContent = String(quantity);
    count.hidden = quantity === 0;
    bag.setAttribute('aria-label', `Bag, ${quantity} ${quantity === 1 ? 'item' : 'items'}`);
  });
}

// Use the confirmed cart total, since a product-form event's itemCount can be a delta.
document.addEventListener(StandardEvents.cartLinesUpdate, (event) => {
  event.promise?.then(({ cart }) => showCount(cart?.totalQuantity)).catch(() => {});
});

window.addEventListener('pageshow', (event) => {
  if (!event.persisted) return;
  const bag = document.querySelector('[data-wpi-bag]');
  if (!bag) return;
  fetch(`${bag.dataset.cartUrl}.js`, { credentials: 'same-origin' })
    .then((response) => response.ok ? response.json() : null)
    .then((cart) => showCount(cart?.item_count))
    .catch(() => {});
});
